/**
 * Redux actions for local content.
 * @module redux/actions/axisOrders
 */

import { createAction } from "redux-actions";
import {
  getDeliveryFeed as apiGetDeliveryFeed,
  getOrderStatus as apiGetOrderStatus,
  getMapStatus as apiGetMapStatus
} from "../api/axis";

export const REQUEST_DELIVERY_FEED = "AXIS_ORDERS/REQUEST_DELIVERY_FEED";
export const DELIVERY_FEED_RECEIVED = "AXIS_ORDERS/DELIVERY_FEED_RECEIVED";
export const REQUEST_DELIVERY_FEED_FAILED =
  "AXIS_ORDERS/REQUEST_DELIVERY_FEED_FAILED";

export const REQUEST_ORDER_STATUS = "AXIS_ORDERS/REQUEST_ORDER_STATUS";
export const ORDER_STATUS_RECEIVED = "AXIS_ORDERS/ORDER_STATUS_RECEIVED";
export const REQUEST_ORDER_STATUS_FAILED =
  "AXIS_ORDERS/REQUEST_ORDER_STATUS_FAILED";
export const ORDER_ITEMS_TOGGLED = "AXIS_ORDERS/ORDER_ITEMS_TOGGLED";

export const REQUEST_MAP_STATUS = "AXIS_ORDERS/REQUEST_DELIVERY_FEED";
export const MAP_STATUS_RECEIVED = "AXIS_ORDERS/MAP_STATUS_RECEIVED";
export const REQUEST_MAP_STATUS_FAILED =
  "AXIS_ORDERS/REQUEST_MAP_STATUS_FAILED";

const deliveryFeedReceived = feed =>
  createAction(DELIVERY_FEED_RECEIVED)({
    feed: feed.feed
  });
const mapStatusReceived = mapStatus =>
  createAction(MAP_STATUS_RECEIVED)({
    maps: mapStatus.maps
  });
export const toggleOrderItemsVisibility = (id, expanded) =>
  createAction(ORDER_ITEMS_TOGGLED)({ id, expanded });

export function orderStatusReceived(orderStatus) {
  const status = JSON.parse(orderStatus);
  if (status && status.orders) {
    return (dispatch, getState) =>
      dispatch(
        createAction(ORDER_STATUS_RECEIVED)({
          orderStatus: status.orders.map(o => ({
            ...o,
            url: `${status.baseOrderUrl}${o.guid}`,
            expanded:
              getState().axisOrders.orders.find(
                os => os.id === o.id && os.expanded
              ) !== undefined
          }))
        })
      );
  }
}

export function getDeliveryFeed() {
  return (dispatch, getState) => {
    if (getState().axisOrders.deliveryFeedLoading) {
      return;
    }
    dispatch(createAction(REQUEST_DELIVERY_FEED)());
    apiGetDeliveryFeed()
      .then(feed => dispatch(deliveryFeedReceived(JSON.parse(feed))))
      .catch(error => {
        console.log(error);
        return dispatch(createAction(REQUEST_DELIVERY_FEED_FAILED)());
      });
  };
}

export function getOrderStatus() {
  return (dispatch, getState) => {
    if (getState().axisOrders.orderStatusLoading) {
      return;
    }
    dispatch(createAction(REQUEST_ORDER_STATUS)());
    apiGetOrderStatus()
      .then(orderStatus => dispatch(orderStatusReceived(orderStatus)))
      .catch(error => {
        console.log(error);
        return dispatch(createAction(REQUEST_ORDER_STATUS_FAILED)());
      });
  };
}

export function getMapStatus() {
  return (dispatch, getState) => {
    if (getState().axisOrders.mapStatusLoading) {
      return;
    }
    dispatch(createAction(REQUEST_MAP_STATUS)());
    apiGetMapStatus()
      .then(mapStatus => dispatch(mapStatusReceived(mapStatus)))
      .catch(error => {
        console.log(error);
        return dispatch(createAction(REQUEST_MAP_STATUS_FAILED)());
      });
  };
}

export const actions = {
  getDeliveryFeed,
  getOrderStatus,
  getMapStatus,
  toggleOrderItemsVisibility
};



// WEBPACK FOOTER //
// ./app/actions/axisOrders.js